import { mutations as TYPES } from "./types";

const mutations = {
  [TYPES.OBS_EXPERIENCE]: (state, { data, time }) => {
    state.experience.data = data;
    state.experience.time = time;
  },
  [TYPES.OBS_DESCRIBES]: (state, { business, industry, specifySelect, specifyValue, data, time }) => {
    state.describes.business = business;
    state.describes.industry = industry;
    state.describes.specifySelect = specifySelect;
    state.describes.specifyValue = specifyValue;
    state.describes.data = data;
    state.describes.time = time;
  },
  [TYPES.OBS_PRIMARYGOAL]: (state, { optionsValue, specifyValue, specifySelect, data, time }) => {
    state.primaryGoal.optionsValue = optionsValue;
    state.primaryGoal.specifyValue = specifyValue;
    state.primaryGoal.specifySelect = specifySelect;
    state.primaryGoal.data = data;
    state.describes.time = time;
  },
  [TYPES.OBS_SUBSCRIBE]: (state, {data, time}) => {
    state.isSubscribe.data = data;
    state.isSubscribe.time = time;
  },
  [TYPES.OBS_UPDATE_STATUS]: (state, { success = false, error = false }) => {
    state.status.success = success;
    state.status.error = error;
  },
  [TYPES.OBS_RECUSE_DATA]: (state, data) => {
    state = data;
  },
};

export default mutations;
